import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	inject,
} from '@angular/core';
import { IActionConfig } from '../interfaces';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActionCenterService } from '@app/core/services/action-center.service';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'action-center-footer',
	imports: [CommonModule, MatIconModule, MatButtonModule, NgxTolgeeModule],
	templateUrl: './action-center-footer.component.html',
	styleUrl: './action-center-footer.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionCenterFooterComponent {
	private readonly actionCenterService = inject(ActionCenterService);

	@Input() activeConfig: IActionConfig = null;

	@Output() applyAction = new EventEmitter<void>();
	@Output() closeDialog = new EventEmitter<void>();
	enableApplyBtn = toSignal(this.actionCenterService.enableApplyButton$);
}
